// extracted by mini-css-extract-plugin
module.exports = {"container":"beneficiaryEvent_container__19EQ0","benNumber":"beneficiaryEvent_benNumber__19fEU","benName":"beneficiaryEvent_benName__3qh90"};